import React from 'react';
import { AUAutocompleteUserField } from '@assertiva/assertiva-ui';

const AutocompleteUserField = (props) => {
  return <AUAutocompleteUserField {...props} />;
};

export default AutocompleteUserField;
